const duration_levels = [
    [31536000, "Y"],
    [86400*7, "W"],
    [86400, "D"],
    [3600, "H"],
    [60, "M"],
    [1, "S"],
];

export function humanize_duration(seconds, max_levels=1000){
    var text = "";
    console.log("HUMANIZE", seconds);
    for (var i = 0; i < duration_levels.length && max_levels > 0; i++) {
        const [duration, level] = duration_levels[i];
        const periods = Math.floor(seconds / duration)

        if(periods == 0){ // Skip this level
            continue;
        }

        text += `${periods}${level}`;
        seconds -= periods * duration;
        max_levels--;
    };

    console.log("HUMANIZE", seconds, text);
    return text.trim();
}

export function parse_duration(duration_str){
    if(Number.isInteger(duration_str)){
        return duration_str; // we already have an integer
    }
    const duration_regex = /(\d+)([ywdhms])/gi;

    const durations = [...duration_str.matchAll(duration_regex)];

    const levels = Object.fromEntries( duration_levels.map( ([x,y]) => [y, x]) );
    console.log(duration_str, durations, levels);

    var seconds = 0;
    for(let [_, duration, level] of durations){
        level = level.toUpperCase();
        seconds += (levels[level] || 0) * duration;
        console.log(duration, level, seconds);
    }
    return seconds;
}
